import { Fragment } from "react";
import { TopBannerPanel } from "../HomeNew/topBannerList";
import { NewProductCategoryContainer } from "../HomeNew/newCategoryGrid";
import { NewProductAlgolia } from "../HomeNew/newProductAlgolia";
import { FeaturedProducts } from "../HomeNew/featuredProducts";
import { SpecialProductAlgolia } from "../HomeNew/specialProductContainer";
import { EbookPosterContainer } from "../HomeNew/ebookPosterContainer";
import { ClearanceProductAlgolia } from "../HomeNew/clearanceProductAlgolia";
import { useGuestClickGuard } from "../../Context/hook/useGuestClickGuard";

export const GuestHomeMain = () => {
  const handleGuestClick = useGuestClickGuard();

  return (
    <Fragment>
      <div className="guest-home-wrapper" onClickCapture={handleGuestClick}>
        <TopBannerPanel />
        <NewProductCategoryContainer />
        <NewProductAlgolia />
        <FeaturedProducts />
        <SpecialProductAlgolia />
        <EbookPosterContainer />
        <ClearanceProductAlgolia />
      </div>
    </Fragment>
  );
};
